// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Registros de tiempo para todas las subactividades:',
    ActivityChildrenEstimatedHours_Text: 'Horas estimadas para todas las subactividades:',
    ActivityOwnBudget_Text: 'Presupuesto de la actividad:',
    ActivityOwnEstimatedHours_Text: 'Horas estimadas para la actividad:',
    ActivitySubactivitiesBudget_Text: 'Presupuesto para todas las subactividades:',
    ActualCompletion_Text: 'Finalización real',
    ActualHours_Total_Text: 'Horas trabajadas reales, total:',
    AddTimeEntry_Text: 'Agregar entrada de tiempo',
    AddUser_Text: 'Invitar Usuario',
    Apply: 'Aplicar',
    Assignees_Text: 'Cesionarios',
    BudgetedCost_Text: 'Presupuesto Total del Proyecto:',
    BudgetPadding_Text: 'Contingencia:',
    BudgetTotal_Text: 'Presupuesto total:',
    Cancel: 'Cancelar',
    Close: 'Cerrar',
    Combobox_Add: 'Agregar ',
    Combobox_KeepTyping: 'Sigue escribiendo...',
    Combobox_NoResults: 'Sin resultados',
    Combobox_NoResultsMatch: 'Ningún resultado coincide ',
    Cost_Text: 'Facturación:',
    CreateAndSelect: 'Crear y seleccionar',
    CustomerLabel: 'Cliente',
    Duration_Text: 'Duración',
    EditProjectMembers_Title: 'Miembros del proyecto',
    EditTaskAssignees_Title: 'Cesionarios',
    End_Text: 'Final',
    EndDate_Text: 'Fecha de finalización',
    EstimatedHours_Text: 'Horas estimadas:',
    EstimatedHours_Total_Text: 'Horas estimadas, total:',
    Hours_Short_Text: 'h',
    HoursLeftLabel: 'Horas restantes:',
    InternalCost_Text: 'Coste Real:',
    NonProjectMembers_Text: 'No miembros del proyecto',
    Overloaded_Text: 'Sobrecargar',
    OwnActualHours_Text: 'Registros de tiempo de la actividad:',
    PlannedExpenses_Text: 'Gastos Planificados:',
    PortfolioLabel: 'Portafolio',
    Progress: 'Progreso',
    ProgressCalculatedBySubActivities: 'Basado en el progreso de las subactividades',
    ProjectChildrenActualHours_Text: 'Registros de tiempo para actividades:',
    ProjectChildrenEstimatedHours_Text: 'Horas estimadas para todas las actividades:',
    ProjectMembers_Text: 'Miembros del proyecto',
    ProjectOwnBudget_Text: 'Presupuesto de mano de obra para el proyecto:',
    ProjectOwnEstimatedHours_Text: 'Horas estimadas para el proyecto:',
    ProjectSubactivitiesBudget_Text: 'Presupuesto de todas las actividades:',
    Start_Text: 'Comienzo',
    StartDate_Text: 'Fecha de Inicio',
    Teams_Text: 'Equipos',
    Tooltip_Dependent_Template: '{0} está vinculado a una actividad dependiente y no se puede cambiar',
    Tooltip_HasChildren_Template: '{0} se calcula en función de las subactividades y no se puede cambiar',
    Tooltip_ItemCompleted: 'No se puede editar ya que está vinculado a una actividad/proyecto cerrado.',
    Untitled: 'Sin título',
    Validation_ActComplDateRange: 'La fecha de finalización real no se encuentra dentro del rango esperado.',
    Validation_DateMandatory: 'La fecha es un campo obligatorio.',
    Validation_DurationMandatory: 'La duración es un campo obligatorio.',
    Validation_EndDateRange: 'La fecha de finalización no se encuentra dentro del rango esperado.',
    Validation_FieldMandatory: 'Este es un campo obligatorio.',
    Validation_FromDateRange: 'A partir de la fecha no cae dentro del rango esperado.',
    Validation_Interger: 'El valor debe ser entero.',
    Validation_InvalidDate: 'La fecha debe estar en \'{0}\' formato.',
    Validation_NumberRange: 'El valor debe estar entre {0} y {1}.',
    Validation_Range: 'El valor no se encuentra dentro del rango esperado.',
    Validation_StartDateRange: 'La fecha de inicio no se encuentra dentro del rango esperado.',
    Validation_ToDateRange: 'Hasta la fecha no se encuentra dentro del rango esperado.',
    Validation_WeekendOrVacation: 'El valor no debe caer en un fin de semana o feriado.',
    Warning_UnassigneFromAllTasksInProject: 'Los miembros eliminados no serán asignados a ninguna de las actividades de este proyecto.',
};
